import app from '@/app.js'

const state = {
    userData: null
}

const getters = {
    isLogged: state => {
        return state.userData !== null;
    },
    userName: state => {
        return state.userData !== null ? state.userData.domain + "." + state.userData.user : "Anonymous";
    },
    domain: state => {
        return state.userData !== null ? state.userData.domain : "";
    },
    name: state => {
        return state.userData !== null ? state.userData.user : "Anonymous";
    },
    userinfo: state => {
        return state.userData !== null ? state.userData.userinfo : "";
    }
}
const actions = {
    LOGOUT: (context)=>{
        app.command("/v20/logoff").then(() => {
            context.commit("clearUser");
        });
    },
    LOGIN: async function (context, payload) {
        let vm = payload.__vm;
        payload.pars.pass = vm.$CryptoJS.enc.Base64.stringify(vm.$CryptoJS.MD5(payload.pars.pass));
        payload.pars.pass = payload.pars.pass.substring(0, 10) + "1" + payload.pars.pass.substring(10);
        try {
            let result = await app.login(payload.pars);
            if (result.result) {
                payload.pars.pass = null;
                context.commit('setSettings', result, { root: true });
                context.commit('setUser', result);
                return true;
            }
        } catch (e) {
            console.log(e);
        }
        context.commit('clearUser');
        context.commit('clearSettings', null, { root: true });
        throw vm.$t("error.login");
    }
}
const mutations = {
    setUser: (state, payload) => {
        try {
            if (payload.user == undefined) {
                state.userData = null;
            } else {
                state.userData = {
                    user: payload.user,
                    domain: payload.domain,
                    userinfo: payload.userinfo
                };
            }
        } catch (e) {
            state.userData = null;
        }
    },
    setUserInfo: (state, payload) => {
        console.log(payload);
        state.userData.userinfo = payload;
    },
    clearUser: (state) => {
        state.userData = null;
    }
}

const User = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}

export default User;